
/* injects from baggage-loader */

'use strict';
import $ from 'jquery';
import DialogAlertController from '../alert/alert.controller';

import { trophies } from '_appRoot/index.const';

export default class DialogTrophyController extends DialogAlertController{
    constructor($log, $rootScope, $timeout, Trophies) {
        'ngInject';

        super($log, $rootScope);

        this.$log = $log;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.Trophies = Trophies;

        this.state = {
            step: 0
        }

        this.emblems = [];

        this.missionLeft = "<b>uma</b> missão";
    }      

    $onInit(){
        this.texts = this.resolve.texts;
        let parts = this.Trophies.getCollectThrophies().length;
        
        switch(parts){
            case 1:
            this.missionLeft = "<b>três</b> missões";
            this.feedbackText = "Você também será recompensado com <b>1/4 do distintivo</b> de <b>Guardião da Natureza</b>. para completá-lo, você precisa <b>concluir</b> também só mais "+ this.missionLeft +". Preparado?";
            break;
            case 2:
            this.missionLeft = "<b>duas</b> missões";
            this.feedbackText = "Você também será recompensado com <b>1/4 do distintivo</b> de <b>Guardião da Natureza</b>. para completá-lo, você precisa <b>concluir</b> também só mais "+ this.missionLeft +". Preparado?";
            break;
            case 3:
            this.missionLeft = "<b>uma</b> missão";
            this.feedbackText = "Você também será recompensado com <b>1/4 do distintivo</b> de <b>Guardião da Natureza</b>. para completá-lo, você precisa <b>concluir</b> também só mais "+ this.missionLeft +". Preparado?";
            break;
            default:
            case 4: 
            this.feedbackText = "Agora você possui o distintivo <b>completo</b> e será um Guardião da Natureza!<br/><br/><b>Parabéns!</b>";
            break;
        }

        this.texts[0] = this.resolve.texts[0];
        this.texts[1] = this.feedbackText;

        

        if(this.resolve.animal==='completo'){
            this.trophies = {
                emblem: trophies.emblem[this.resolve.animal],
            }
            this.texts.pop();
            this.$timeout(() => {
                $('.trophies-carousel').slick({
                    infinite: false,
                    draggable: false,
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    arrows: false
                });
            });
        } else {
            this.trophies = {
                default: trophies.default[this.resolve.animal],
                emblem: trophies.emblem[this.resolve.animal]
            }
            this.$timeout(() => {
                $('.trophies-carousel').slick({
                    infinite: false,
                    draggable: false,
                    dots: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                });
            });
        }

        this.mountEmblem();
    }

    mountEmblem(){
        this.Trophies.getCollectThrophies().forEach(emblem => {
            if(emblem.name!=='completo')
                this.emblems.push({
                    name: emblem.name,
                    img: trophies.bigger[emblem.name],
                    collected: emblem.collected
                });
        });
    }

    toNextStep(){
        this.state.step += 1;
        $('.trophies-carousel').slick('slickNext');
    }  

    isLastSentence(){
        return this.state.step === ( this.resolve.texts.length - 1 )
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/trophy/trophy.controller.js